import { attachGameGroupId, buildReferralQuery } from './deeplink';

/** 下单后跳转 Payment 页，payload 内附带 gid */
export function serializePaymentPayload(data, gameGroupId) {
  return JSON.stringify(attachGameGroupId(data, gameGroupId));
}

export function paymentRoute(data, gameGroupId) {
  return {
    name: 'Payment',
    params: { data: serializePaymentPayload(data, gameGroupId) },
  };
}

export function pushPayment(router, data, gameGroupId) {
  router.push(paymentRoute(data, gameGroupId));
}

const SELECT_WALLET_ORDER_KEY = 'select_wallet_order';

export function makeOrderNo() {
  const date = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const stamp =
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}` +
    `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  return stamp + String(Math.floor(Math.random() * 100000)).padStart(6, '0');
}

/** 缓存待支付订单，供 SelectWallet 构建深链接 */
export function stashSelectWalletOrder(payload) {
  try {
    sessionStorage.setItem(SELECT_WALLET_ORDER_KEY, JSON.stringify(payload || {}));
  } catch {
    /* ignore */
  }
}

export function readSelectWalletOrder() {
  try {
    const raw = sessionStorage.getItem(SELECT_WALLET_ORDER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** 下单后跳转选择钱包页 */
export function pushSelectWallet(router, data, gameGroupId) {
  const payload = attachGameGroupId({ ...data }, gameGroupId);
  stashSelectWalletOrder(payload);
  const amount = Number(payload.price || 0) * Number(payload.inputNumber || 1);
  router.push({
    name: 'SelectWallet',
    query: buildReferralQuery(payload.referral_code, gameGroupId, {
      amount: String(amount),
      orderNo: payload.orderNo || '',
    }),
  });
}
